import React, { ReactNode } from 'react';
interface GroupSettingsProps {
    title: string;
    children: ReactNode[];
}

export const GroupSetting: React.FC<GroupSettingsProps> = ( { title, children } ) => {

  return (
    <div key={''} className="p-6 pb-8 rounded-xl border bg-white my-3 w-full h-fit">
      <h2 className="text-xl font-semibold mb-4 text-gray-700">
        { title }
      </h2>
      <div className="flex flex-col gap-4">
        { children }
      </div>
    </div>
  );
};

export default GroupSetting;